"use client";

interface DatePriceCTAProps {
  date: string;
  price: number | string;
  discounted?: number | string;
  tourId: string;
  available: boolean;
  capacity?: string | number;
}

export default function DatePriceCTA({
  date,
  price,
  discounted,
  tourId,
  available,
  capacity,
}: DatePriceCTAProps) {
  const finalPrice = discounted || price;

  const getCapacityLabel = (count: string | number): string => {
    const num = parseInt(String(count), 10);
    if (isNaN(num)) return "voľných miest";
    if (num === 1) return "voľné miesto";
    if (num >= 2 && num <= 4) return "voľné miesta";
    return "voľných miest";
  };

  return (
    <div className='flex w-full p-2 md:p-3 h-27.75 md:h-32.5 max-w-137.5 mx-auto bg-[#141414] text-white rounded-[36px]'>
      <div className='flex flex-col justify-center items-cente flex-1'>
        <p className='text-lg md:text-xl md:max-w-[50%] mx-auto px-4 font-semibold'>
          {date}
        </p>
        {capacity !== "0" && capacity !== "" && (
          <p className='text-sm md:text-[16px]'>
            <span className='text-[#619F1C] mr-1 font-semibold'>
              {capacity}
            </span>
            {capacity != null && getCapacityLabel(capacity)}
          </p>
        )}
      </div>
      <div className='flex flex-col h-23.75 md:h-26.5 w-26.25 md:w-44.75 rounded-[28px]'>
        <div className='flex flex-col justify-center h-full rounded-t-[28px] items-center bg-[#3C5523]'>
          <p className='text-xl md:text-2xl mt-1 font-semibold'>
            {finalPrice}€
          </p>
          {discounted && (
            <p className='text-[#7FA35E] line-through text-xs md:text-sm'>
              Cena inde {price}€
            </p>
          )}
        </div>
        {available ? (
          <button
            onClick={() => {
              if (typeof window !== "undefined") {
                window.dataLayer = window.dataLayer || [];

                const uniqueTripId = Math.floor(
                  100000 + Math.random() * 900000
                );

                window.dataLayer.push({
                  event: "travel_add_to_cart",
                  event_id: "add_" + uniqueTripId,
                  trip_id: tourId,
                  trip_date: date,
                  trip_name: tourId,
                  value: Number(finalPrice),
                  currency: "EUR",
                  user_email: null,
                });

                window.location.href = `/objednavka?tour=${encodeURIComponent(
                  tourId
                )}&date=${encodeURIComponent(date)}`;
              }
            }}
            className='flex justify-center p-3 rounded-b-[28px] cursor-pointer h-10 items-center bg-[#619F1C] hover:bg-[#507C1A] text-white font-semibold text-sm'
          >
            Objednať
          </button>
        ) : (
          <button
            className='flex justify-center items-center h-10 rounded-b-[28px]  bg-gray-400 text-white font-bold py-4 text-sm cursor-not-allowed'
            disabled
          >
            Obsadené
          </button>
        )}
      </div>
    </div>
  );
}
